import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { Loader, Menu, UnstyledButton } from '@mantine/core'

import type { ButtonMenuProps } from '@/components/ButtonMenu/ButtonMenu.types'

import classes from './ButtonMenu.module.css'

export function ButtonMenu({
  items,
  label,
  loading,
  onItemSelect,
  ...props
}: ButtonMenuProps) {
  const [opened, setOpened] = useState(false)

  return (
    <Menu
      {...props}
      onChange={setOpened}
      opened={opened}
      position="top"
      radius={8}
      width={308}
    >
      <Menu.Target>
        <UnstyledButton
          className={`${classes.menuButton} ${opened && classes.menuButtonActive}`}
        >
          {loading ? (
            <Loader color="white" mx="auto" size="sm" type="dots" />
          ) : (
            label
          )}
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown className={classes.menuDropdown}>
        {items.map(item => (
          <Menu.Item
            key={item.label}
            className={classes.menuItem}
            component={NavLink}
            onClick={() =>
              onItemSelect && item.param
                ? onItemSelect(item.param)
                : onItemSelect && onItemSelect()
            }
            to=""
          >
            {item.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}
